import FullPageLoadingSpinner from './FullPageLoadingSpinner';

export default FullPageLoadingSpinner;
